export const INPUT_LABEL = "Phone";
export const INPUT_PLACEHOLDER = "Enter Phone Number Here";
export const SEND_PIN_BUTTON_TEXT = "Send PIN Code";
export const VERIFY_CODE_CONFIRM_CODE_BUTTON_TEXT = "Confirm Code";
export const VERIFY_CODE_INPUT_LABEL = "Code";
export const VERIFY_CODE_INPUT_PLACEHOLDER = "PIN sent to phone number";
export const VERIFY_CODE_RESEND_PIN_BUTTON_TEXT = "Resend Pin";

export default {
  INPUT_LABEL,
  INPUT_PLACEHOLDER,
  SEND_PIN_BUTTON_TEXT,
  VERIFY_CODE_CONFIRM_CODE_BUTTON_TEXT,
  VERIFY_CODE_INPUT_LABEL,
  VERIFY_CODE_INPUT_PLACEHOLDER,
  VERIFY_CODE_RESEND_PIN_BUTTON_TEXT,
};
